import Header from "../../Header/Header";
import Footer from "../../Footer/Footer";

import "./homeLayout.scss";

const HomeLayout = ({ children }) => {
  return (
    <main className="hLayout flex flex-col overflow-hidden pt-16">
      <Header onHome />

      {children}

      <Footer />
    </main>
  );
};

export default HomeLayout;
